import { render, staticRenderFns } from "./PositionEdit.vue?vue&type=template&id=0c01fbfa&scoped=true&"
import script from "./PositionEdit.vue?vue&type=script&lang=js&"
export * from "./PositionEdit.vue?vue&type=script&lang=js&"
import style0 from "./PositionEdit.vue?vue&type=style&index=0&id=0c01fbfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c01fbfa",
  null
  
)

export default component.exports